import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import './global.scss';

import { App } from './App';
import { AuthProvider } from '@app/AuthProvider';
import { StoreProvider } from './store/store';
import { ThemeProvider } from '@igo/ui';
import { BrowserRouter } from 'react-router-dom';
import ScrollRestoration from './ScrollRestoration';
import ErrorBoundary from './errorBoundary/ErrorBoundary';
import { FullscreenProvider } from './FullscreenProvider';
import { AudioProvider } from './AudioProvider';

createRoot(document.getElementById('root')!).render(
    // <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
            <ErrorBoundary>
                <ScrollRestoration />
                <AuthProvider>
                    <ThemeProvider>
                        <StoreProvider>
                            <FullscreenProvider>
                                <AudioProvider>
                                    <App />
                                </AudioProvider>
                            </FullscreenProvider>
                        </StoreProvider>
                    </ThemeProvider>
                </AuthProvider>
            </ErrorBoundary>
        </BrowserRouter>
    </Suspense>
    // </React.StrictMode>
);
